import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from "@angular/material/dialog";
import { FmSystemList } from "../../../_model/fmSystemList-response/fmSystemList";


@Component({
  selector: 'app-fmSystemList-chooser',
  templateUrl: './fmSystemList-chooser.component.html',
  standalone: true,
  imports: [MatDialogModule],
  styleUrls: ['./fmSystemList-chooser.component.scss']
})
export class FmSystemListChooserComponent implements OnInit {

  public fmSystemLists!: FmSystemList[];

  constructor(private matDialogRef: MatDialogRef<FmSystemListChooserComponent, FmSystemList>,
              @Inject(MAT_DIALOG_DATA) private data: { fmSystemLists: FmSystemList[]; trigger: ElementRef }) {
  }

  ngOnInit() {
    this.fmSystemLists = this.data.fmSystemLists;
    const rect = this.data.trigger.nativeElement.getBoundingClientRect();
    this.matDialogRef.updatePosition({left: `${rect.left}px`, top: `${rect.bottom + 13}px`});
  }

  updateFmSystemList(fmSystemList: FmSystemList) {
    this.matDialogRef.close(fmSystemList);
  }
}
